import * as React from "react";
import classnames from "classnames";
import { Button } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css                             */
const StoreBookAppointmentCTA = ({ className, labels, onClick, ...rest }) => /* @__PURE__ */ React.createElement(
  Button,
  {
    ...rest,
    className: classnames("store-book-appointment-cta-stores-v2", className),
    variant: "solid",
    onClick
  },
  /* @__PURE__ */ React.createElement("span", { className: "store-book-appointment-cta-stores-v2__icon" }, /* @__PURE__ */ React.createElement(Icon, { name: "calendar" })),
  labels.caption
);
export {
  StoreBookAppointmentCTA as default
};
//# sourceMappingURL=StoreBookAppointmentCTA.js.map
